/**
 * Product Page Dynamic Swatches
 * Atualiza a página de produto via AJAX ao clicar em swatch de cor linkado
 */

(function () {
  'use strict';

  var section = document.querySelector('[data-section-type="product"]');
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var snapReloadTimer = null;
  var snapReloadInProgress = false;
  var pendingHiddenSnapWidgets = null;

  // Elementos que serão atualizados
  var galleryGrid = section.querySelector('.product-gallery-grid');
  var mobileDots = section.querySelector('.mobile-dots');
  var galleryScroll = section.querySelector('.product-gallery-scroll');

  var titleEl = document.querySelector('[data-pd-title]');
  var priceEl = document.querySelector('[data-pd-price]');
  var compareEl = document.querySelector('[data-pd-compare]');
  var colorNameEl = section.querySelector('[data-pd-current-color]');
  var formEl = document.getElementById('product-form-' + sectionId);
  var variantInput = document.getElementById('variant-id-' + sectionId);
  var addToCartBtn = document.getElementById('add-to-cart-btn-' + sectionId);
  var sizeContainer = section.querySelector('[data-pd-size-options]');
  var descEl = section.querySelector('[data-pd-description]');

  // Observer existente — precisamos recriar ao trocar galeria
  var observer = null;

  // Delegação de clique nos swatches
  section.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pd-swatch]');
    if (!btn) return;

    var handle = btn.dataset.pdSwatch;
    if (!handle) return;

    // Evita clique no já ativo
    var currentHandle = btn.closest('[data-pd-current-handle]');
    if (currentHandle && currentHandle.dataset.pdCurrentHandle === handle) return;

    e.preventDefault();

    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    Promise.all([
      fetch('/products/' + handle + '.js').then(function (res) {
        if (!res.ok) throw new Error('Produto não encontrado');
        return res.json();
      }),
      fetch('/products/' + handle, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (res) {
        if (!res.ok) throw new Error('HTML do produto não encontrado');
        return res.text();
      })
    ])
      .then(function (results) {
        var product = results[0];
        var productHtml = results[1];
        updateProductPage(product, handle, productHtml);
        btn.classList.remove('is-loading');

        // Atualiza estado ativo dos swatches
        section.querySelectorAll('[data-pd-swatch]').forEach(function (b) {
          var swatchCircle = b.querySelector('span');
          var isActive = b.dataset.pdSwatch === handle;
          b.classList.toggle('is-active-swatch', isActive);
          if (swatchCircle) {
            swatchCircle.classList.toggle('is-active-swatch', isActive);
          }
        });
      })
      .catch(function (err) {
        console.error('Erro ao carregar produto:', err);
        btn.classList.remove('is-loading');
      });
  });

  function updateProductPage(product, handle, productHtml) {
    // ===== URL do navegador =====
    if (window.history && window.history.pushState) {
      window.history.pushState({ handle: handle }, product.title, '/products/' + handle);
    }

    // ===== TÍTULO =====
    if (titleEl) titleEl.textContent = product.title;
    document.title = product.title + ' \u2013 ' + (window.Shopify && window.Shopify.shop ? window.Shopify.shop.split('.')[0] : '');

    // ===== NOME DA COR =====
    if (colorNameEl) {
      var activeSwatch = section.querySelector('[data-pd-swatch].is-active-swatch');
      if (!activeSwatch) {
        activeSwatch = section.querySelector('[data-pd-swatch]');
      }
      if (activeSwatch && activeSwatch.dataset.pdColorName) {
        colorNameEl.textContent = activeSwatch.dataset.pdColorName;
      }
    }


    // ===== PREÇO =====
    if (priceEl) priceEl.textContent = formatMoney(product.price);

    if (compareEl) {
      if (product.compare_at_price && product.compare_at_price > product.price) {
        compareEl.textContent = formatMoney(product.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // ===== VARIANT INPUT =====
    var firstVariant = product.variants && product.variants[0];
    if (variantInput && firstVariant) {
      variantInput.value = firstVariant.id;
    }

    // ===== ADD TO CART =====
    if (addToCartBtn && firstVariant) {
      addToCartBtn.disabled = !firstVariant.available;
      addToCartBtn.textContent = firstVariant.available ? (addToCartBtn.dataset.originalText || 'Adicionar ao carrinho') : 'Esgotado';
    }

    // ===== DESCRIÇÃO =====
    if (descEl && product.description) {
      descEl.innerHTML = product.description;
    }

    updateSnapSections(productHtml);

    // ===== GALERIA =====
    rebuildGallery(product);

    // ===== TAMANHOS =====
    rebuildSizeOptions(product);

    // Atualiza o JSON do produto para o novo
    var jsonScript = document.getElementById('product-json-' + sectionId);
    if (jsonScript) {
      jsonScript.textContent = JSON.stringify(product);
    }
    section.dispatchEvent(new CustomEvent('product:updated', { detail: { product: product } }));

    // Atualiza o handle atual
    var currentHandleEl = section.querySelector('[data-pd-current-handle]');
    if (currentHandleEl) {
      currentHandleEl.dataset.pdCurrentHandle = handle;
    }
  }

  function updateSnapSections(productHtml) {
    if (!productHtml) {
      reinitializeSnapWidgets(document.getElementById('MainContent') || section);
      return;
    }

    var doc = new DOMParser().parseFromString(productHtml, 'text/html');
    var currentMain = document.getElementById('MainContent');
    var nextMain = doc.getElementById('MainContent');

    if (currentMain && nextMain) {
      replaceProductSnapTryon(nextMain);
      replaceSectionByKey('product_description', currentMain, nextMain);
      replaceSectionByKey('snap_reviews', currentMain, nextMain);
    }

    reinitializeSnapWidgets(currentMain || section);
  }

  function replaceProductSnapTryon(nextRoot) {
    var currentTryon = section.querySelector('.product-snap-tryon');
    var nextProductSection = nextRoot.querySelector('[data-section-type="product"]');
    var nextTryon = nextProductSection && nextProductSection.querySelector('.product-snap-tryon');

    if (currentTryon && nextTryon) {
      currentTryon.innerHTML = nextTryon.innerHTML;
    }
  }

  function replaceSectionByKey(sectionKey, currentRoot, nextRoot) {
    var currentSection = findSectionByKey(currentRoot, sectionKey);
    var nextSection = findSectionByKey(nextRoot, sectionKey);

    if (currentSection && nextSection) {
      currentSection.innerHTML = nextSection.innerHTML;
      executeInlineScripts(currentSection);
    }
  }

  function findSectionByKey(root, sectionKey) {
    if (!root) return null;
    return root.querySelector('[id$="__' + sectionKey + '"], [id*="__' + sectionKey + '__"]');
  }

  function executeInlineScripts(container) {
    container.querySelectorAll('script').forEach(function (script) {
      if (script.src) return;
      if (script.type && script.type !== 'text/javascript' && script.type !== 'application/javascript') return;

      var newScript = document.createElement('script');
      Array.prototype.slice.call(script.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.text = script.textContent;
      document.head.appendChild(newScript).parentNode.removeChild(newScript);
    });
  }

  function reinitializeSnapWidgets(container) {
    if (!container || !container.querySelector('[data-snap-tryon], [data-snap-video], [data-snap-video-feed], [data-snap-reviews], [data-snap-instagram]')) {
      return;
    }

    if (snapReloadTimer) {
      window.clearTimeout(snapReloadTimer);
      snapReloadTimer = null;
    }
    restoreSnapWidgets(pendingHiddenSnapWidgets);

    var hiddenWidgets = hideSnapWidgetsOutside(container);
    pendingHiddenSnapWidgets = hiddenWidgets;
    var calledInitializer = callSnapInitializer(container);

    [
      'snap:init',
      'snap:load',
      'snap:widgets:init',
      'snap:widgets:reload'
    ].forEach(function (eventName) {
      document.dispatchEvent(new CustomEvent(eventName, { detail: { container: container } }));
    });

    scheduleSnapScriptFallback(container, calledInitializer ? 500 : 0, hiddenWidgets);
  }

  function callSnapInitializer(container) {
    var called = false;
    var candidates = [
      [window.Snap, ['initAll', 'init', 'load', 'reload', 'render']],
      [window.snap, ['initAll', 'init', 'load', 'reload', 'render']],
      [window.SnapSolutions, ['initAll', 'init', 'load', 'reload', 'render']],
      [window.snapSolutions, ['initAll', 'init', 'load', 'reload', 'render']],
      [window.SnapWidgets, ['initAll', 'init', 'load', 'reload', 'render']],
      [window.snapWidgets, ['initAll', 'init', 'load', 'reload', 'render']]
    ];

    candidates.forEach(function (candidate) {
      var target = candidate[0];
      var methods = candidate[1];
      if (!target) return;

      if (typeof target === 'function') {
        try {
          target(container);
          called = true;
        } catch (err) {
          console.warn('Erro ao reinicializar Snap:', err);
        }
        return;
      }

      methods.forEach(function (method) {
        if (typeof target[method] !== 'function') return;
        try {
          target[method](container);
          called = true;
        } catch (err) {
          console.warn('Erro ao reinicializar Snap:', err);
        }
      });
    });

    return called;
  }

  function scheduleSnapScriptFallback(container, delay, hiddenWidgets) {
    snapReloadTimer = window.setTimeout(function () {
      snapReloadTimer = null;
      if (hasEmptySnapWidget(container)) {
        reloadSnapScript(container, hiddenWidgets);
      } else {
        restoreSnapWidgets(hiddenWidgets);
      }
    }, delay);
  }

  function hasEmptySnapWidget(container) {
    if (!container || !document.documentElement.contains(container)) return false;

    var widgets = container.querySelectorAll('[data-snap-video], [data-snap-video-feed], [data-snap-reviews], [data-snap-instagram], [data-snap-tryon]');
    return Array.prototype.some.call(widgets, isEmptySnapWidget);
  }

  function reloadSnapScript(container, hiddenWidgets) {
    if (snapReloadInProgress) {
      restoreSnapWidgets(hiddenWidgets);
      return;
    }

    var currentScript = document.querySelector('script[src*="snapsolutions.com.br"][src*="snap.js"]');
    if (!currentScript || !currentScript.src) {
      restoreSnapWidgets(hiddenWidgets);
      return;
    }

    var initializedWidgets = hideInitializedSnapWidgets(container);
    snapReloadInProgress = true;
    var script = document.createElement('script');
    Array.prototype.slice.call(currentScript.attributes).forEach(function (attr) {
      if (attr.name === 'src') return;
      script.setAttribute(attr.name, attr.value);
    });
    script.src = currentScript.src;
    script.defer = true;
    script.dataset.hmultiAjaxReload = 'true';
    script.addEventListener('load', function () {
      setTimeout(function () {
        if (script.parentNode) script.parentNode.removeChild(script);
        snapReloadInProgress = false;
        restoreSnapWidgets(hiddenWidgets);
        restoreSnapWidgets(initializedWidgets);
      }, 1000);
    });
    script.addEventListener('error', function () {
      if (script.parentNode) script.parentNode.removeChild(script);
      snapReloadInProgress = false;
      restoreSnapWidgets(hiddenWidgets);
      restoreSnapWidgets(initializedWidgets);
    });
    document.head.appendChild(script);

    window.setTimeout(function () {
      if (!snapReloadInProgress) return;
      snapReloadInProgress = false;
      if (script.parentNode) script.parentNode.removeChild(script);
      restoreSnapWidgets(hiddenWidgets);
      restoreSnapWidgets(initializedWidgets);
    }, 5000);
  }

  function hideSnapWidgetsOutside(container) {
    var hiddenWidgets = [];
    var selector = '[data-snap-tryon], [data-snap-video], [data-snap-video-feed], [data-snap-reviews], [data-snap-instagram]';

    document.querySelectorAll(selector).forEach(function (widget) {
      if (container.contains(widget)) return;

      var hiddenAttrs = [];
      Array.prototype.slice.call(widget.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-snap-') !== 0) return;
        hiddenAttrs.push({ name: attr.name, value: attr.value });
        widget.removeAttribute(attr.name);
      });

      if (hiddenAttrs.length > 0) {
        hiddenWidgets.push({ element: widget, attrs: hiddenAttrs });
      }
    });

    return hiddenWidgets;
  }

  function hideInitializedSnapWidgets(container) {
    var hiddenWidgets = [];
    var selector = '[data-snap-tryon], [data-snap-video], [data-snap-video-feed], [data-snap-reviews], [data-snap-instagram]';

    if (!container || !document.documentElement.contains(container)) return hiddenWidgets;

    container.querySelectorAll(selector).forEach(function (widget) {
      if (isEmptySnapWidget(widget)) return;

      var hiddenAttrs = [];
      Array.prototype.slice.call(widget.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-snap-') !== 0) return;
        hiddenAttrs.push({ name: attr.name, value: attr.value });
        widget.removeAttribute(attr.name);
      });

      if (hiddenAttrs.length > 0) {
        hiddenWidgets.push({ element: widget, attrs: hiddenAttrs });
      }
    });

    return hiddenWidgets;
  }

  function isEmptySnapWidget(widget) {
    if (!widget) return false;
    return widget.children.length === 0 && widget.textContent.trim() === '';
  }

  function restoreSnapWidgets(hiddenWidgets) {
    if (!hiddenWidgets || hiddenWidgets.length === 0) return;

    hiddenWidgets.forEach(function (entry) {
      if (!entry.element || !document.documentElement.contains(entry.element)) return;

      entry.attrs.forEach(function (attr) {
        entry.element.setAttribute(attr.name, attr.value);
      });
    });

    if (hiddenWidgets === pendingHiddenSnapWidgets) {
      pendingHiddenSnapWidgets = null;
    }
  }

  function rebuildGallery(product) {
    if (!product.images || product.images.length === 0) return;

    // Gallery grid
    if (galleryGrid) {
      var gridHTML = '';
      var isHeroLayout = galleryGrid.classList.contains('product-gallery-grid--hero');
      product.images.forEach(function (img, idx) {
        if (isHeroLayout) {
          gridHTML += '<div class="product-gallery-item product-gallery-item--hero" data-index="' + idx + '" id="product-image-' + sectionId + '-' + idx + '">' +
            '<img src="' + img + '" alt="' + product.title + '" class="product-hero-image" width="800" height="1000" loading="' + (idx === 0 ? 'eager' : 'lazy') + '">' +
            '</div>';
        } else {
          gridHTML += '<div class="product-gallery-item" data-index="' + idx + '" id="product-image-' + sectionId + '-' + idx + '">' +
            '<img src="' + img + '" alt="' + product.title + '" class="w-full" width="800" height="1000" loading="' + (idx === 0 ? 'eager' : 'lazy') + '">' +
            '</div>';
        }
      });
      galleryGrid.innerHTML = gridHTML;
    }

    // Mobile dots
    if (mobileDots) {
      var dotsHTML = '';
      product.images.forEach(function (img, idx) {
        dotsHTML += '<button type="button" class="mobile-dot ' + (idx === 0 ? 'is-active' : '') + '" data-index="' + idx + '" aria-label="Imagem ' + (idx + 1) + '"></button>';
      });
      mobileDots.innerHTML = dotsHTML;
    }

    // Reconfigura observer
    if (observer) {
      observer.disconnect();
    }

    if (galleryScroll && galleryGrid) {
      var items = galleryGrid.querySelectorAll('.product-gallery-item');
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = parseInt(entry.target.dataset.index, 10);
              var dots = section.querySelectorAll('.mobile-dot');
              dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
            }
          });
        },
        { root: galleryScroll, threshold: 0.5 }
      );
      items.forEach(function (item) { observer.observe(item); });
    }

    // Scrolla para o topo da galeria
    if (galleryScroll) {
      galleryScroll.scrollTo({ left: 0, behavior: 'auto' });
    }

    // Reconfigura clicks nos dots (galeria antiga perdeu os listeners)
    if (mobileDots) {
      mobileDots.querySelectorAll('.mobile-dot').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.dataset.index, 10);
          var items = galleryGrid ? galleryGrid.querySelectorAll('.product-gallery-item') : [];
          if (items[idx]) {
            items[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          }
          mobileDots.querySelectorAll('.mobile-dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
        });
      });
    }
  }

  function rebuildSizeOptions(product) {
    if (!sizeContainer) return;

    // Procura opção de tamanho
    var sizeOption = null;
    var sizeOptionIndex = -1;
    if (product.options) {
      product.options.forEach(function (opt, idx) {
        var name = (opt.name || opt || '').toLowerCase();
        if (name.indexOf('tamanho') !== -1 || name.indexOf('size') !== -1) {
          sizeOption = opt;
          sizeOptionIndex = idx;
        }
      });
    }

    if (sizeOptionIndex === -1) {
      sizeContainer.innerHTML = '';
      sizeContainer.style.display = 'none';
      return;
    }

    sizeContainer.style.display = '';
    sizeContainer.dataset.optionIndex = sizeOptionIndex;

    // Preserva tamanho atualmente selecionado
    var currentSize = null;
    var currentInput = sizeContainer.querySelector('input[name="option' + (sizeOptionIndex + 1) + '"]:checked');
    if (currentInput) {
      currentSize = currentInput.value;
    }

    // Coleta valores únicos de tamanho das variantes
    var values = [];
    var seen = {};
    if (product.variants) {
      product.variants.forEach(function (v) {
        var val = v.options[sizeOptionIndex];
        if (val && !seen[val]) {
          seen[val] = true;
          values.push(val);
        }
      });
    }
    if (values.length === 0) {
      sizeContainer.innerHTML = '';
      return;
    }

    var html = '';
    var hasChecked = false;
    values.forEach(function (value, idx) {
      var isAvailable = optionValueAvailable(product, sizeOptionIndex, value);
      var isChecked = (currentSize && currentSize === value && isAvailable) || (!currentSize && isAvailable && !hasChecked);
      if (isChecked) hasChecked = true;
      html += '<label>' +
        '<input type="radio" name="option' + (sizeOptionIndex + 1) + '" value="' + escapeHtml(value) + '" class="size-option sr-only" ' + (isChecked ? 'checked' : '') + ' data-size-swatch' + (isAvailable ? '' : ' disabled aria-disabled="true"') + '>' +
        '<span class="product-size-circle">' + escapeHtml(value) + '</span>' +
      '</label>';
    });
    sizeContainer.innerHTML = html;

    // Dispara change no input checked para atualizar preço/variante na página
    var checkedInput = sizeContainer.querySelector('input[data-size-swatch]:checked');
    if (checkedInput) {
      checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return 'R$ ' + value;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function optionValueAvailable(product, optionIndex, value) {
    if (!product || !product.variants) return true;
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available && variant.options && variant.options[optionIndex] === value) {
        return true;
      }
    }
    return false;
  }
})();
